import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';
import { getGovernanceAllQueryOptions } from '@/_pages/governance/api-service';

export const Route = createFileRoute('/_private/governance/')({
  validateSearch: filterState.parse,
  staticData: { isFullWidth: true },
  loader: (opts) => opts.context.queryClient.ensureQueryData(getGovernanceAllQueryOptions()),
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={5} />,
});
